import React from "react"

const Logo = props => {
  return (
    <img
      alt="stones-throw-logo"
      src={require("../images/logo-white.png")}
      width="55"
      className="logo"
    />
  )
}

export default Logo
